import {
  GET_ALL_CALENDAR_REQUEST,
  GET_ALL_CALENDAR_SUCCESS,
  GET_ALL_CALENDAR_ERROR,
  CREATE_CALENDAR_REQUEST,
  CREATE_CALENDAR_SUCCESS,
  CREATE_CALENDAR_ERROR,
  UPDATE_CALENDAR_REQUEST,
  UPDATE_CALENDAR_SUCCESS,
  UPDATE_CALENDAR_ERROR,
  DELETE_CALENDAR_REQUEST,
  DELETE_CALENDAR_SUCCESS,
  DELETE_CALENDAR_ERROR,

} from "../actions/types";

export const calendar = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_CALENDAR_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_CALENDAR_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_ALL_CALENDAR_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };
    case CREATE_CALENDAR_REQUEST:
      return {
        loading: true,
      };
    case CREATE_CALENDAR_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case CREATE_CALENDAR_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    case UPDATE_CALENDAR_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CALENDAR_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case UPDATE_CALENDAR_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };
    case DELETE_CALENDAR_REQUEST:
      return {
        loading: true,
      };
    case DELETE_CALENDAR_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case DELETE_CALENDAR_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
